import { useEffect, useMemo } from 'react';
import { PICPAY_PROJECT } from 'App/featuresFlags';
import { useHasTags, useIsBoldProject } from 'App/hooks';
import { useGoToPlans } from 'commons/hooks/useGoToPlans';
import { AffiliateDiscountPercentageAlert } from './AffiliateDiscountPercentageAlert';
import { BoldProjectAffiliateDiscountAlert } from './BoldProjectAffiliateDiscountAlert';
import useTrialMessages from './useTrialMessages/useTrialMessages';

function TrialMessages() {
  const { getTrialMessages, trialMessage, isSuccess } = useTrialMessages();
  const [isPicpay] = useHasTags(PICPAY_PROJECT);
  const { isMobileNonFreemium } = useGoToPlans();
  const isBoldProject = useIsBoldProject();

  const discountPercentage = useMemo(
    () =>
      // applies to the custom discount percentage for stores from the PicPay partner
      isPicpay ? 20 : trialMessage?.affiliateDiscountPercentage,
    [isPicpay, trialMessage],
  );

  useEffect(() => {
    getTrialMessages();
  }, [getTrialMessages]);

  if (isBoldProject) return <BoldProjectAffiliateDiscountAlert />;

  if (!isSuccess) return null;

  const mobileSuffix = isMobileNonFreemium ? 'Mobile' : '';

  return (
    <AffiliateDiscountPercentageAlert
      mobileSuffix={mobileSuffix}
      affiliateDiscountPercentage={discountPercentage}
      show={trialMessage?.showMessage}
    />
  );
}

export default TrialMessages;
